import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SimuladorNumericInput from "./SimuladorNumericInput";
import { SimuladorIncentivoAnualOR } from "./SimuladorIncentivosAnualOR";
import BuildIcon from '@mui/icons-material/Build';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';
import { SimuladorIncentivosPosventaRefacciones } from "./SimuladorInsentivosPosventaRefacciones";
import { SimuladorIncentivosPosventaServicio } from "./SimuladorIncentivosPosventaServicio";

const SimuladorIncentivosPosventaScreen = ({ puesto }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        puesto: "",
        fecha: "",
        monto: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    //SUELDO
    const [datos, setDatos] = useState({
        sueldo: 0,
        incentivo: 0,
        margenRefacciones: "",
        margenServicio: "",
        porcentajeTecnicos: ""
    });

    const handleChangeDatos = (e) => {
        const { name, value } = e.target;
        setDatos({
            ...datos,
            [name]: value,
        });
    };

    const rangoBajoR = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.30 },
        { minimo: 90, maximo: 99.99, porcentaje: .35 },
        { minimo: 100, maximo: 109.99, porcentaje: .45 },
        { minimo: 110, maximo: 150000, porcentaje: .50 },
    ]

    const rangoMedioR = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.35 },
        { minimo: 90, maximo: 99.99, porcentaje: .40 },
        { minimo: 100, maximo: 109.99, porcentaje: .50 },
        { minimo: 110, maximo: 150000, porcentaje: .55 },
    ]

    const rangoAltoR = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.40 },
        { minimo: 90, maximo: 99.99, porcentaje: .45 },
        { minimo: 100, maximo: 109.99, porcentaje: .60 },
        { minimo: 110, maximo: 150000, porcentaje: .65 },
    ]


    //SERVICIO

    const rangoBajoS = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.30 },
        { minimo: 90, maximo: 99.99, porcentaje: .35 },
        { minimo: 100, maximo: 109.99, porcentaje: .45 },
        { minimo: 110, maximo: 150000, porcentaje: .50 },
    ]

    const rangoMedioS = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.35 },
        { minimo: 90, maximo: 99.99, porcentaje: .40 },
        { minimo: 100, maximo: 109.99, porcentaje: .50 },
        { minimo: 110, maximo: 150000, porcentaje: .55 },
    ]

    const rangoAltoS = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.40 },
        { minimo: 90, maximo: 99.99, porcentaje: .45 },
        { minimo: 100, maximo: 109.99, porcentaje: .60 },
        { minimo: 110, maximo: 150000, porcentaje: .65 },
    ]

    //INCENTIVO TOTAL
    const [incentivoTotalRefacciones, setIncentivoTotalRefacciones] = useState(0);
    const [incentivoTotalServicio, setIncentivoTotalServicio] = useState(0)

    const [incentivoTotal, setIncentivoTotal] = useState(0)


    useEffect(() => {
        let incentivo = 0;

        incentivo =
            Number(incentivoTotalRefacciones) + Number(incentivoTotalServicio);

        setIncentivoTotal(incentivo)
    }, [incentivoTotalRefacciones, incentivoTotalServicio]);


    return (
        <>
            <div className="simulador-incentivo-form-seccion">
                <div className="input-section-container-base-salary">
                    <div className="input-section">
                        <div className="input-section-label">
                            SALARIO BASE
                        </div>

                        <SimuladorNumericInput
                            name="sueldo"
                            label=""
                            value={datos.sueldo}
                            disabled={false}
                            onChange={handleChangeDatos}
                            icono="pesos"
                        />

                    </div>
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon /> Refacciones
                    </div>
                    <SimuladorIncentivosPosventaRefacciones
                        rango={datos.margenRefacciones < 20.01 ? rangoBajoR : datos.margenRefacciones < 22.01 ? rangoMedioR : rangoAltoR}
                        sueldo={datos.sueldo}
                        setIncentivoTotalRefacciones={setIncentivoTotalRefacciones}
                        handleChangeDatos={handleChangeDatos}
                        margenRefacciones={datos.margenRefacciones}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <CarRepairIcon sx={{ fontSize: "18px" }} /> Servicio
                    </div>
                    <SimuladorIncentivosPosventaServicio
                        rango={datos.margenServicio < 40.01 ? rangoBajoS : datos.margenServicio < 42.01 ? rangoMedioS : rangoAltoS}
                        sueldo={datos.sueldo}
                        setIncentivoTotalServicio={setIncentivoTotalServicio}
                        handleChangeDatos={handleChangeDatos}
                        margenServicio={datos.margenServicio}
                    />
                </div>
            </div>
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulos">
                    <span>
                        Considerando los datos ingresados, tu Incentivo total simulado es:
                    </span>

                    <SimuladorNumericInput
                        name="incentivoTotal"
                        label=""
                        value={incentivoTotal}
                        disabled={true}
                        align="centro"
                        icono="pesos"
                    />
                </div>
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
        </>
    );
};

export default SimuladorIncentivosPosventaScreen;
